import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    topupShort: '{{missing}} short — top up',
    bandJoinToOpen: 'Join SHOT BAND to open',
    bandInsufficientBonusButton: 'Not enough sparks',
    bandInsufficientBonusHint: 'Sparks are cashback for playing, not something you buy.',
  },
  ru: {
    topupShort: 'Не хватает {{missing}} — пополнить',
    bandJoinToOpen: 'Вступи в SHOT BAND',
    bandInsufficientBonusButton: 'Не хватает искр',
    bandInsufficientBonusHint: 'Искры не купишь — их даёт кешбэк за игру.',
  },
  uz: {
    topupShort: '{{missing}} yetmaydi — toʻldirish',
    bandJoinToOpen: 'SHOT BANDʼga qoʻshil',
    bandInsufficientBonusButton: 'Uchqunlar yetarli emas',
    bandInsufficientBonusHint: 'Uchqunlar — oʻyin uchun keshbek, sotib olinmaydi.',
  },
  fa: {
    topupShort: '{{missing}} کم است — شارژ کن',
    bandJoinToOpen: 'برای باز کردن به SHOT BAND بپیوند',
    bandInsufficientBonusButton: 'جرقه کم است',
    bandInsufficientBonusHint: 'جرقه کش‌بک بازی کردن است، خریدنی نیست.',
  },
  pt: {
    topupShort: 'Faltam {{missing}} — depositar',
    bandJoinToOpen: 'Entre no SHOT BAND',
    bandInsufficientBonusButton: 'Faíscas insuficientes',
    bandInsufficientBonusHint: 'Faíscas não se compram — vêm do cashback por jogar.',
  },
  tr: {
    topupShort: '{{missing}} eksik — yatır',
    bandJoinToOpen: "SHOT BAND'e katıl",
    bandInsufficientBonusButton: 'Yeterli kıvılcım yok',
    bandInsufficientBonusHint: 'Kıvılcım satın alınmaz — oyun için cashback olarak verilir.',
  },
  uk: {
    topupShort: 'Не вистачає {{missing}} — поповнити',
    bandJoinToOpen: 'Вступи до SHOT BAND',
    bandInsufficientBonusButton: 'Не вистачає іскор',
    bandInsufficientBonusHint: 'Іскри не купиш — їх дає кешбек за гру.',
  },
  de: {
    topupShort: 'Es fehlen {{missing}} – aufladen',
    bandJoinToOpen: 'Tritt SHOT BAND bei',
    bandInsufficientBonusButton: 'Nicht genug Funken',
    bandInsufficientBonusHint: 'Funken kann man nicht kaufen – sie kommen als Cashback fürs Spielen.',
  },
  es: {
    topupShort: 'Faltan {{missing}} — recargar',
    bandJoinToOpen: 'Únete a SHOT BAND',
    bandInsufficientBonusButton: 'No hay suficientes chispas',
    bandInsufficientBonusHint: 'Las chispas no se compran: las da el cashback por jugar.',
  },
  pl: {
    topupShort: 'Brakuje {{missing}} — doładuj',
    bandJoinToOpen: 'Dołącz do SHOT BAND',
    bandInsufficientBonusButton: 'Za mało iskier',
    bandInsufficientBonusHint: 'Iskier nie kupisz — dostajesz je w ramach cashbacku za grę.',
  },
});
